// extracted by mini-css-extract-plugin
module.exports = {"canvas":"ReviewToolPreview_canvas__0vc5A"};